import { create } from "zustand";
import t from "../locales";

export const birthyearValue =
  new Date().getFullYear() - t("secrets_birthyear_age");

export const useNotepadStore = create((set) => ({
  secrets: {
    email: false,
    password: false,
    holiday: false,
    birthday: false,
    sportteam: false,
    city: false,
    chiro: false,
    pet: false,
    band: false,
    phonenumber: false,
    birthyear: false,
  },
  saveInfo: (info) =>
    set((state) => ({ secrets: { ...state.secrets, [info]: true } })),
}));

function generateSecrets(secrets) {
  return {
    email: {
      label: t("secrets_email_label"),
      value: t("secrets_email_value"),
      hidden: t("secrets_email_hidden"),
    },
    password: {
      label: t("secrets_password_label"),
      value: t("secrets_password_value"),
      hidden: t("secrets_password_hidden"),
    },
    holiday: {
      label: t("secrets_holiday_label"),
      value: t("secrets_holiday_value"),
      hidden: t("secrets_holiday_hidden"),
    },
    birthday: {
      label: t("secrets_birthday_label"),
      // birthyear has to be appended as t(secrets_birthday_value) only holds day and month.
      value: `${t("secrets_birthday_value")}/${birthyearValue}`,
      // if birthyear is guessed, return hash of hidden and visible part for separate styling
      hidden: secrets.birthyear
        ? {
            visibleYear: birthyearValue,
            hiddenDate: t("secrets_birthday_hidden"),
          }
        : `${t("secrets_birthday_hidden")}/${t("secrets_birthyear_hidden")}`,
    },
    sportteam: {
      label: t("secrets_sportteam_label"),
      value: t("secrets_sportteam_value"),
      hidden: t("secrets_sportteam_hidden"),
    },
    city: {
      label: t("secrets_city_label"),
      value: t("secrets_city_value"),
      hidden: t("secrets_city_hidden"),
    },
    chiro: {
      label: t("secrets_chiro_label"),
      value: t("secrets_chiro_value"),
      hidden: t("secrets_chiro_hidden"),
    },
    pet: {
      label: t("secrets_pet_label"),
      value: t("secrets_pet_value"),
      hidden: t("secrets_pet_hidden"),
    },
    band: {
      label: t("secrets_band_label"),
      value: t("secrets_band_value"),
      hidden: t("secrets_band_hidden"),
    },
    phonenumber: {
      label: t("secrets_phonenumber_label"),
      value: t("secrets_phonenumber_value"),
      hidden: t("secrets_phonenumber_hidden"),
    },
  };
}

export let secrets = generateSecrets(useNotepadStore.getState().secrets);

useNotepadStore.subscribe(
  (state) => (secrets = generateSecrets(state.secrets)),
);
